declare var jQuery:any;
declare var $:any;

// Imports Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Compiler } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

// External Modules
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './configuracion/material.module';
import { SessionStorageService } from 'ngx-webstorage';
import { Ng2Webstorage } from 'ngx-webstorage';
import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { Logger } from 'angular2-logger/core';

/*translation */
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Components view
import { AppComponent } from './app.component';
import { PieComponent } from './components/pie/pie.component';
import { PagoComponent } from './components/pago/pago.component';
import { CabeceraFormularioComponent } from './components/formulario/cabecera-formulario/cabecera-formulario.component';
import { ContenedorFormularioComponent } from './components/formulario/contenedor-formulario/contenedor-formulario.component';
import { FormularioComponent } from './components/formulario/formulario/formulario.component';
import { DFirmaComponente } from '@dian-cmp/firma';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DSpeedDialComponente } from '@dian-cmp/speed-dial';
import { DatepickerModule } from '@dian-cmp/datepicker';
import { DPreguntasComponente } from '@dian-cmp/preguntas';
import { DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DReciboPagoModule } from '@dian-cmp/recibo-pago';

// Libs framework
import { DLogger } from '@dian/core';
import { DLoggerAngular } from '@dian/core';
import { DContextoMuiscaServicio } from '@dian/core';
import { DSessionStorage } from '@dian/core';
import { DContextoMuiscaDesaServicio } from '@dian/core';
import { DFormularioServicio } from '@dian/api-formulario';
import { 
  DInterfaceConfiguracionFormulario, 
  DOperacionesMatematicasServicio, 
  DValidacionesFormularioServicio,
  DAyudasFormularioServicio, 
  DRenderizarPorParametrosDirectiva,
  DMostrarAyudaDirectiva,
  FormateoValorPipe,
  FormatoMonedaDirectiva,
  DMostrarAyudaBaseComponent
} from '@dian-cmp/formulario';

// Conf
import { 
  loggerFactory, 
  contextoMuiscaFactory, 
  formularioFactory, 
  validacionesFormularioFactory, 
  sessionStorageFactory, 
  ayudasFormularioFactory, 
  HttpLoaderTranslatorFactory 
} from './configuracion/app.factories';
import { DFormularioConfiguracion } from './configuracion/dformulario-configuracion';
import { DAyudasFormulario } from './configuracion/dayudas-formulario';
import { MissingTranslationHandlerDIAN } from './configuracion/missing-translation-handler-dian';
import { AppRoutingModule } from './app-routing.module';
import { DateInputMaskFormsDirectiva } from './configuracion/date-input-mask.directive';
import { Ng2FabSpeedDialModule } from 'ng2-fab-speed-dial';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule } from '@angular/material';
import { DialogoImpuestoSimpleComponent } from './components/formulario/dialogo-impuesto-simple/dialogoimpsimp.component';
import { CommonModule } from '@angular/common';
import { TableItemsComponent } from './components/table-items/table-items.component';
import { DialogoSiNoComponent } from './components/table-items/dialogo-si-no/dialogo-si-no.component';
import { ModalIdTributarioComponent } from './components/modal/modalidtributario.component';


@NgModule({
  declarations: [
    AppComponent,
    PieComponent,
    PagoComponent,
    CabeceraFormularioComponent,
    ContenedorFormularioComponent,
    FormularioComponent,
    DNotificacionesComponente,
    DSpeedDialComponente,
    DFirmaComponente,
    DEnvioLogComponente,
    DPreguntasComponente,
    FormateoValorPipe,
    FormatoMonedaDirectiva,
    DRenderizarPorParametrosDirectiva,
    DMostrarAyudaDirectiva,
    DMostrarAyudaBaseComponent,
    DateInputMaskFormsDirectiva,
    DialogoImpuestoSimpleComponent,
    TableItemsComponent,
    DialogoSiNoComponent,
    ModalIdTributarioComponent,

    
  ],
  imports: [
    //Angular
    CommonModule,
    BrowserModule,
    HttpModule, 
    FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),
    //Traductor
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderTranslatorFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler, 
        useClass: MissingTranslationHandlerDIAN
      }
    }),
    //Material
    FlexLayoutModule,
    MaterialModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    DatepickerModule,
    DateValueAccessorModule,  
    DReciboPagoModule,  
    MatDialogModule,
    MatButtonModule,
    //Aplicacion
    AppRoutingModule,
    Ng2FabSpeedDialModule
  ],
  exports: [
    MatIconModule,
    TranslateModule
  ],
  providers: [
    CookieService, 
    Compiler,
    Logger,
    DNotificacionServicio,
    {
        provide: DLogger,
        useFactory: loggerFactory,
        deps: [Logger, SessionStorageService]
    },
    {
        provide: DSessionStorage,
        useFactory: sessionStorageFactory,
        deps: [SessionStorageService,DLogger]
    },
    {
        provide: DContextoMuiscaServicio,
        useFactory: contextoMuiscaFactory,
        deps: [Http, CookieService, Compiler, DLogger, DNotificacionServicio, DSessionStorage, DFormularioConfiguracion]
    },  
    {
        provide: DFormularioServicio,
        useFactory: formularioFactory,
        deps: [DContextoMuiscaServicio]            
    },  
    {
        provide: DValidacionesFormularioServicio,
        useFactory: validacionesFormularioFactory,
        deps: [DFormularioConfiguracion, DOperacionesMatematicasServicio]
    },       
    {
        provide: DAyudasFormularioServicio,
        useFactory: ayudasFormularioFactory,
        deps: [DAyudasFormulario]
    },  
    FormateoValorPipe,
    DOperacionesMatematicasServicio,
    DFormularioConfiguracion,
    DAyudasFormulario,
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    DNotificacionesComponente, 
    DEnvioLogComponente,
    DFirmaComponente,
    DPreguntasComponente,
    PagoComponent,
    DialogoSiNoComponent,
    ModalIdTributarioComponent
  ]
})
export class AppModule { 

  /**
  * @constructor
  */
  constructor(){
    this.abrirAyuda();
  }

  /**
  * @desc Funcion para iniciar la ayuda 
  */
  private abrirAyuda() {
    //trigger ayuda pie
    setTimeout(function(){
      var seg = 0;
      $('.ayuda').tapTarget('open');  
      setInterval(function(){
        seg++;
        if(seg === 5){
          $('.ayuda').tapTarget('close');
          cerrarAyudaBtn();           
        }
      }, 1000);
    }, 3000);
      
    //Funcion para cerrar la ayuda y eliminarla para prevenir que se vuelva a abrir
    function cerrarAyudaBtn(){
      $('.ayuda').tapTarget('close'); 
      $("#btn-ayuda").show(); 
    }
  }  

}





// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/app.module.ts